'use strict';

wbApp.filter('boolean', ['$translate', function ($translate) {
    return function (input) {
        return input ? $translate.instant('TXT_BTN_YES') : $translate.instant('TXT_BTN_NO');
    };
}]);